import { render, staticRenderFns } from "./CreateAlbum.vue?vue&type=template&id=1ff63be7&scoped=true&"
import script from "./CreateAlbum.vue?vue&type=script&lang=js&"
export * from "./CreateAlbum.vue?vue&type=script&lang=js&"
import style0 from "./CreateAlbum.vue?vue&type=style&index=0&id=1ff63be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff63be7",
  null
  
)

export default component.exports